/**
 * ユーティリティ関数群
 */
'use strict';
import store from '../store';
import constants from '../common/constants';

/**
 * APIのURLを取得する
 * @param {String} name 取得するAPIの識別文字列
 */
export function apiUrl(name) {
  for (let i = 0; i < constants.apiDef.length; i++) {
    const api = constants.apiDef[i];
    if (api.name.toLowerCase() == name.toLowerCase()) {
      return store.state.apiOrigin + api.url;
    }
  }
  return '';
}

// ユーザ認証APIのURL
export function authUrl() {
  //return store.state.apiOrigin + 'api/users/authenticate';
  return apiUrl('authorize');
}
// 地番データ取得APIのURL
export function chibanURL() {
  //return store.state.apiOrigin + 'api/Chiban';
  return apiUrl('Chiban');
}
// 建築計画概要書データ取得APIのURL
export function gaiyoURL() {
  //return store.state.apiOrigin + 'api/Gaiyo';
  return apiUrl('Gaiyo');
}
// 建築計画概要書一覧データ取得APIのURL
export function gaiyoSummaryURL() {
  //return store.state.apiOrigin + 'api/GaiyoSummary';
  return apiUrl('GaiyoSummary');
}
// 同一物件概要書一覧データ取得APIのURL
export function estateUrl() {
  //return store.state.apiOrigin + 'api/Estate';
  return apiUrl('Estate');
}
// 昇降機データ取得APIのURL
export function elvUrl() {
  //return store.state.apiOrigin + 'api/Elv';
  return apiUrl('Elv');
}
// 昇降機一覧データ取得APIのURL
export function elvSummaryUrl() {
  //return store.state.apiOrigin + 'api/elvSummary';
  return apiUrl('elvSummary');
}
// 定期報告データ取得APIのURL
export function teihoUrl() {
  //return store.state.apiOrigin + 'api/Teiho';
  return apiUrl('Teiho');
}
// 定期報告一覧データ取得APIのURL
export function teihoSummaryUrl() {
  //return store.state.apiOrigin + 'api/Teiho';
  return apiUrl('TeihoSummary');
}

// 背景地形図タイルのURL
export function bgmapUrl() {
  return store.state.mapOrigin + 'ykhdm/{z}/{x}/{y}.png';
}
// 建築確認プロットタイルのURL
export function plotUrl() {
  return store.state.mapOrigin + constants.tileDef[store.state.mode].url;
}
export function plotUrlAlt() {
  if (store.state.mode == 5) {
    return store.state.mapOrigin + constants.tileDef[6].url;
  }
  else {
    return '';
  }
}
// 建築計画概要書第三面画像ディレクトリのURL
export function imgUrl() {
  return store.state.imgOrigin;
}
// 旧概要書画像ディレクトリのURL
export function imgOldUrl() {
  return store.state.imgOldOrigin;
}
// 概要書画像の拡張子
export function imgExt() {
  return store.state.imgExt;
}

export function daichoURL() {
  //return store.state.apiOrigin + 'api/Chiban';
  return apiUrl('Dancho');
}
export function daichoIMG() {
  //return store.state.apiOrigin + 'api/Chiban';
  return apiUrl('DanchoImage');
}
export function ULog() {
  //return store.state.apiOrigin + 'api/Chiban';
  return apiUrl('ULog');
}

/**
 * 日付文字列を和暦文字列に変換する
 * @param {String} date yyyymmdd形式の日付文字列
 * @returns 和暦文字列を返す
 */
export function dateTextToWareki(date) {
  if (date) {
    try {
      const year = date.substr(0, 4);
      const month = date.substr(5, 2);
      const day = date.substr(8, 2);
      date = new Date(year, month - 1, day);
      return new Intl.DateTimeFormat(
        'ja-JP-u-ca-japanese',
        {
          era: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        }
      ).format(date);
    }
    catch (err) {
      dbglog(`dateTextToWareki(${date}): ${err}`, -1);
      return '';
    }
  }
  else {
    return '';
  }
}

/**
 * 西暦年の基準月1日を和暦年度（省略文字列）に変換する
 * @param {Number} year 西暦年
 * @param {Number} month 基準月
 * @returns [S|H|R]99形式の和暦文字列を返す
 */
export function yearToNendo(year, month = 4) {
  const date = new Intl.DateTimeFormat(
    'ja-JP-u-ca-japanese',
    {
      era: 'narrow',
      year: 'numeric',
    }
  ).format(new Date(year, month - 1, 1));

  /* 元年の場合1に変換(ex:H元年、R元年 ⇒ H1,R1)
     上記のIntl.DateTimeFormatではH元年、R元年 等でしか返されないため。
  */
  let nendo = date;
  if(date.endsWith('元年')){
    nendo = date.replace(/元/g,"1");
  }
  return nendo;
}

/**
 * 区コードから区名称を取得する
 * @param {Number} code 区コード
 * @returns codeに一致する区コードを持つ区の名称文字列を返す
 */
export function getWardName(code) {
  for (let i = 0; i < constants.Wards.length; i++) {
    const ward = constants.Wards[i];
    if (ward.code == code) {
      return ward.name;
    }
  }
  return '';
}

/**
 * 区名称から区コードを取得する
 * @param {String} name 区名称
 * @returns nameに一致する名称を持つ区のコードを返す
 */
export function getWardCode(name) {
  for (let i = 0; i < constants.Wards.length; i++) {
    const ward = constants.Wards[i];
    if (ward.name == name) {
      return ward.code;
    }
  }
  return 14000;
}

export function getWardCodeBalics(name) {
  for (let i = 0; i < constants.WardsBalics.length; i++) {
    const ward = constants.WardsBalics[i];
    if (ward.name == name) {
      return ward.code;
    }
  }
  return 14000;
}

export function getWardCodeBalicsName(code) {
  for (let i = 0; i < constants.WardsBalics.length; i++) {
    const ward = constants.WardsBalics[i];
    if (ward.code == code) {
      return ward.name;
    }
  }
  return 14000;
}

export function getWardCodeBalicsShortname(code) {
  for (let i = 0; i < constants.WardsBalics.length; i++) {
    const ward = constants.WardsBalics[i];
    if (ward.code == code) {
      return ward.shortname;
    }
  }
  return 14000;
}

export function getStopSybtName(code) {
  if(code == null) return "";
  
  for (let i = 0; i < constants.stopSybtDef.length; i++) {
    const ward = constants.stopSybtDef[i];
    if (ward.code == code) {
      return ward.name;
    }
  }
  return "";
}

export function getWarekiCode(name) {
  for (let i = 0; i < constants.warekiDef.length; i++) {
    const wareki = constants.warekiDef[i];
    if (wareki.era == name) {
      return wareki.id;
    }
  }
  return "";
}

export function getWarekiName(id) {
  for (let i = 0; i < constants.warekiDef.length; i++) {
    const wareki = constants.warekiDef[i];
    if (wareki.id == id) {
      return wareki.era;
    }
  }
  return "";
}

export function getSyuyoCode(name) {
  for (let i = 0; i < constants.Syuyo.length; i++) {
    const yoto = constants.Syuyo[i];
    if (yoto.name == name) {
      return yoto.code;
    }
  }
  return "";
}

export function getSyuyoName(code) {
  for (let i = 0; i < constants.Syuyo.length; i++) {
    const yoto = constants.Syuyo[i];
    if (yoto.code == code) {
      return yoto.name;
    }
  }
  return "";
}

export function getGutaiSyuyoYotoCode(name) {
  for (let i = 0; i < constants.gutaiSyuyoYotoDef.length; i++) {
    const yoto = constants.gutaiSyuyoYotoDef[i];
    if (yoto.name == name) {
      return yoto.code;
    }
  }
  return "";
}

export function getGutaiSyuyoYotoName(code) {
  for (let i = 0; i < constants.gutaiSyuyoYotoDef.length; i++) {
    const yoto = constants.gutaiSyuyoYotoDef[i];
    if (yoto.code == code) {
      return yoto.name;
    }
  }
  return "";
}

export function getKojiSybtCode(name) {
  for (let i = 0; i < constants.kojiSybtDef.length; i++) {
    const yoto = constants.kojiSybtDef[i];
    if (yoto.name == name) {
      return yoto.code;
    }
  }
  return "";
}

export function getKojiSybtName(code) {
  for (let i = 0; i < constants.kojiSybtDef.length; i++) {
    const yoto = constants.kojiSybtDef[i];
    if (yoto.code == code) {
      return yoto.name;
    }
  }
  return "";
}

export function getKubunCode(name) {
  for (let i = 0; i < constants.kubunDef.length; i++) {
    const yoto = constants.kubunDef[i];
    if (yoto.name == name) {
      return yoto.code;
    }
  }
  return "";
}

export function getKubunName(code) {
  for (let i = 0; i < constants.kubunDef.length; i++) {
    const yoto = constants.kubunDef[i];
    if (yoto.code == code) {
      return yoto.name;
    }
  }
  return "一般";
}

export function geKozoSybtName(code) {
  for (let i = 0; i < constants.KozoSybtDef.length; i++) {
    const yoto = constants.KozoSybtDef[i];
    if (yoto.code == code) {
      return yoto.name;
    }
  }
  return "";
}

export function getKozoSybtCode(name) {
  for (let i = 0; i < constants.KozoSybtDef.length; i++) {
    const yoto = constants.KozoSybtDef[i];
    if (yoto.name == name) {
      return yoto.code;
    }
  }
  return "";
}

export function getKozoSybtName(code) {
  for (let i = 0; i < constants.KozoSybtDef.length; i++) {
    const yoto = constants.KozoSybtDef[i];
    if (yoto.code == code) {
      return yoto.name;
    }
  }
  return "";
}

// デバッグモード（大きいほど多くのログを吐く）
export function debugMode() {
  return store.state.debug;
}

// デバッグ用ログの出力
export function dbglog(msg, level = 0) {
  if (store.state.debug > level) {
    console.log(msg);
  }
}

export function wordwrap(text, len) {
  let result = [];
  if (text && text.length) {
    let start = 0;
    for (let i = 0; i < text.length; i += len) {
      result.push(text.substr(start, len));
      start += len;
    }
    /*
    let count = 0;
    for (let i = 0; i < text.length; i++) {
      const str = text.substr(i, 1);
      if (str.match(/^[^\x01-\x7E\uFF61-\uFF9F]+$/)) {
        result.push(str);
      }
    }
    */
  }
  else {
    result.push('');
  }
  return result;
}


